import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './CardsEmpty.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { CardDataStat } from '@/components/Profile/Cards/Cards.constants';

type CardsEmptyProps = {
  onAddCard: () => void;
};

export const CardsEmpty = ({ onAddCard }: CardsEmptyProps) => {
  const { t } = useTranslation();

  return (
    <S.Section>
      <S.Header>
        <S.Title $variant="2">{t('pages.cabinet.my_cards')}</S.Title>
        <S.AddCardLink onClick={onAddCard} data-stat={CardDataStat.AddNewCard}>
          {t('pages.cabinet.add_new_card')}
        </S.AddCardLink>
      </S.Header>

      <S.Box>
        <IconBox
          $filename="cards-empty.svg"
          $width={100}
          $height={100}
          $iconWidth={100}
          $iconHeight={100}
        />
        <S.EmptyTitle $variant="1">
          {t('pages.cabinet.cards_page_empty_text')}
        </S.EmptyTitle>
      </S.Box>
    </S.Section>
  );
};
